import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment as config } from 'src/environments/environment';
import { TokenInterceptorSkipAccountHeader } from '../constants/interceptors-headers';
import { TrackedPair, TrackedPairsConfig } from '../models/tracked-pairs.models';

@Injectable({
  providedIn: 'root'
})
export class TrackedPairsService {
  private readonly httpClient = inject(HttpClient);

  public getTrackedPairs(accountId: number): Promise<TrackedPair[]> {
    const headers = new HttpHeaders().set(TokenInterceptorSkipAccountHeader, '');

    return lastValueFrom(this.httpClient.get<TrackedPair[]>(
      `${config.adminBaseUrl}/api/TrackedPairs`,
      {
        headers,
        params: { accountId: accountId.toString() }
      }
    ));
  }

  public addTrackedPair(accountId: number, trackedPair: TrackedPairsConfig): Promise<number> {
    const headers = new HttpHeaders().set(TokenInterceptorSkipAccountHeader, '');

    return lastValueFrom(this.httpClient.post<number>(
      `${config.adminBaseUrl}/api/TrackedPairs`,
      trackedPair,
      {
        headers,
        params: { accountId: accountId.toString() }
      }
    ));
  }

  public deleteTrackedPair(accountId: number, trackedPairId: number): Promise<void> {
    const headers = new HttpHeaders().set(TokenInterceptorSkipAccountHeader, '');

    return lastValueFrom(this.httpClient.delete<void>(
      `${config.adminBaseUrl}/api/TrackedPairs/${trackedPairId}`,
      {
        headers,
        params: { accountId: accountId.toString() }
      }
    ));
  }
}
